import ro from './ro.json';
import en from './en.json';
import hu from './hu.json';

export type Locale = 'ro' | 'en' | 'hu';
export type Dictionary = Record<keyof typeof ro, string>;
export const dictionaries = { ro, en, hu } satisfies Record<Locale, Dictionary>;
export const LANGUAGE_STORAGE_KEY = 'my-giving-public.language';
/** The address parameter naming a language, as the mobile app links in its own (`?lang=ro`). */
export const LANGUAGE_QUERY_PARAMETER = 'lang';
export const intlLocales: Record<Locale, string> = { ro: 'ro-RO', en: 'en-GB', hu: 'hu-HU' };

export const isLocale = (value: unknown): value is Locale =>
  value === 'ro' || value === 'en' || value === 'hu';

export const detectBrowserLocale = (languages: readonly string[]): Locale => {
  for (const language of languages) {
    const code = language.trim().toLowerCase().split(/[-_]/)[0];
    if (isLocale(code)) return code;
  }
  return 'ro';
};

export const projectCount = (count: number, locale: Locale): string => {
  const category = new Intl.PluralRules(locale).select(count);
  const t = dictionaries[locale];
  const label =
    category === 'one' ? t.projectOne : category === 'few' ? t.projectFew : t.projectMany;
  return `${new Intl.NumberFormat(intlLocales[locale]).format(count)} ${label}`;
};
